import {
  GETALLTRANSACTION,
  CREATETRANSACTION,
  UPDATEALLTRANSACTION,
  DELETEALLTRANSACTION,
  CREATECHEQUE,
} from "../actions/types";

const initialState = {
    allTransactionList: [], 
  };


export default function (state = initialState, action) {
  switch (action.type) {
    case GETALLTRANSACTION:
      return {
        ...state,
        allTransactionList: action.payload.data,
      };

      case CREATETRANSACTION:
        return {
          ...state,
          createTransactionList: action.payload.data,
        };

      case UPDATEALLTRANSACTION:
      return {
        ...state,
        allTransactionUpateStatus: action.payload.success,
      };

    case DELETEALLTRANSACTION:
      return {
        ...state,
        allTransactionDeleteStatus: action.payload.success,
      };
      case CREATECHEQUE:
        return {
          ...state,
          createChequeList: action.payload.data,
        };
    default:
      return state;
  }
}
